import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import { getTabs } from '../ProductsListContainer/TopBlock';
import ExportTableAction from 'src/components/ExportTableAction';
import { ExportTypeType } from 'src/types/table';

type TopBlockProps = {
    reloadProductSetsList: () => void;
    permissionCreate: boolean;
    handleExport: (type: ExportTypeType) => void;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();

    const handleChange = (newUrl: string) => {
        navigate('/products/' + newUrl);
    };

    const handleNew = () => {
        navigate(`/products/sets/new/`);
    };

    return (
        <BodyTopBlock
            tabs={getTabs()}
            selectTab={'sets'}
            onChangeTab={handleChange}
            actions={[
                {
                    node: (
                        <ExportTableAction
                            title={translate('productSets.action.dowloadProductSetsTable')}
                            handleExport={props.handleExport}
                        />
                    ),
                },
                {
                    onClick: props.reloadProductSetsList,
                    icon: <ReloadIcon />,
                    tooltip: translate('productSets.action.synchronizeTable'),
                    variant: 'outlined',
                },
            ]}
        />
    );
};

export default TopBlock;
